// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2521":"73dd7353fb1cade7","2888":"3816235b3e8777ff","2918":"73dd7353fb1cade7","7054":"73dd7353fb1cade7","7905":"73dd7353fb1cade7"}[chunkId] + ".css";
};